export default {
  revokeToken: 'Révoquer le jeton',
  revokeSelectedTokens: 'Révoquer les jetons sélectionnés',
  tokenExpiration: 'Expiration du jeton',
};
